export default "__VITE_ASSET__DISAj0jU__"